import HeadTittle from '../../../../../components/HeadTittle';
import DivContainerBody from '../../../../../components/DivContainerBody';
import CustomExpandableTable from '../../../../../components/table/CustomExpandableTable';
import DetailsEquipmentMaterialApp from '../Functionality/DetailsEquipmentMaterialApp';
import MaterialAndEquipmentCardGrid from './MaterialAndEquipmentCardGrid';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const DetailsEquipmentMaterial = () => {
    const {
        goBack,
        handleRowExpand,
        t,
        columns,
        sections
    } = DetailsEquipmentMaterialApp();
    return (
        <>
            <HeadTittle name={t('details')} onBack={goBack} />

            <DivContainerBody>
                <div className='row pb-5'>
                    <div className='col-sm-12 col-md-4 col-lg-3 px-0 mb-sm-3'>
                        <MaterialAndEquipmentCardGrid />
                    </div>
                    <div className='col-sm-12 col-md-8 col-lg-9 px-0'>
                        {/**Done*/}
                        <CustomExpandableTable
                            columns={columns}
                            rows={sections}
                            checkbox={false}
                            rowsPerPage={sections.length}
                            selectedList={[]}
                            handleCheckboxChange={() => {}}
                            handleDeleteAll={() => {}}
                            renderExpandedRow={({ row }) => row.content()}
                            renderOptionsMenu={null}
                            onRowExpand={handleRowExpand}
                            tooltip={false}
                            showHeader={false}
                            withoutHeight={true}
                        />
                    </div>
                </div>
            </DivContainerBody>
        </>
    );
};

export default DetailsEquipmentMaterial;
